import * as React from "react";
import { Icon } from "./Icon";

/**
 * Round icon-only button for toolbars, the recorder HUD and top bars. Always pass a label.
 */
export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: string;
  /** Accessible name (also used as tooltip) */
  label: string;
  variant?: "ghost" | "outline" | "solid" | "record" | "now" | "glass" | "muted";
  /** sm 34 · md 40 · lg 56 */
  size?: "sm" | "md" | "lg";
  shape?: "round" | "square";
  /** Purple unread dot */
  badge?: boolean;
  /** Render a stop square instead of an icon */
  stop?: boolean;
  fill?: boolean;
  iconSize?: number;
}

export function IconButton({
  icon,
  label,
  variant = "ghost",
  size = "md",
  shape = "round",
  badge,
  stop,
  fill,
  iconSize,
  className,
  ...rest
}: IconButtonProps): JSX.Element {
  const is = iconSize || (size === "lg" ? 26 : size === "sm" ? 18 : 20);
  const cls = [
    "gk-iconbtn",
    "gk-iconbtn--" + variant,
    size !== "md" && "gk-iconbtn--" + size,
    shape === "square" && "gk-iconbtn--square",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button type="button" aria-label={label} title={label} className={cls} {...rest}>
      {stop ? <span className="gk-iconbtn__stop" /> : icon && <Icon name={icon} size={is} fill={fill} />}
      {badge && <span className="gk-iconbtn__badge" />}
    </button>
  );
}
